import { defineMessages } from 'react-intl';

/**
 * Copy for in-app update failures raised from the `tauriUpdateModel` rematch
 * effects.
 *
 * Lives as react-intl descriptors rather than i18next keys because
 * `src/locales/en/common.json` is the deprecated source and must not gain new
 * strings. Rematch effects have no React context to call `useIntl()` from, so
 * these are formatted through `formatMessageOutsideReact` — the same route
 * `src/tauri/ipc.messages.ts` uses.
 *
 * The copy is deliberately desktop-native: this path only ever runs inside the
 * Tauri app, so no wording may reference a browser, refreshing the page, or the
 * address bar. The remedy offered is the one that actually works — retry, or
 * download the build directly.
 */
export const updateFailureMessages = defineMessages({
  installFailedTitle: {
    defaultMessage: "Couldn't install the update",
    id: 'CxgjlP0m91',
    description:
      'Destructive toast title when an in-app desktop update fails to download or install',
  },
  installFailed: {
    defaultMessage:
      'Heidi is still running the current version. Try again, or download the latest version from our website.',
    id: 'Gw6V8n+MmX',
    description:
      'Destructive toast body when an in-app desktop update fails. The update offer stays on screen so the user can retry.',
  },
  // Kept OS-neutral on purpose: this fires on both macOS (replacing the .app
  // bundle) and Windows (the installer's elevation prompt), so it must not name
  // a folder or a settings pane that only exists on one of them.
  installPermissionDenied: {
    defaultMessage:
      "Heidi couldn't replace the installed app. You may need an administrator to install this update.",
    id: 'A7DR0LjqzJ',
    description:
      'Destructive toast body when the desktop updater downloaded the update but could not replace the installed app because doing so needs elevated permission.',
  },
  installNetworkFailed: {
    defaultMessage:
      "Heidi couldn't reach the update server. Check your connection, or ask your IT team whether the network is blocking it.",
    id: 'M0GtX2HPrP',
    description:
      'Destructive toast body when the desktop updater could not download the update because the network or a proxy blocked it.',
  },
  checkFailedTitle: {
    defaultMessage: "Couldn't check for updates",
    id: 'Wjy4IPWiLH',
    description:
      'Destructive toast title when a user-initiated desktop update check fails',
  },
  checkFailed: {
    defaultMessage: 'Try again in a moment.',
    id: 'WLJfMxabMH',
    description:
      'Destructive toast body when a user-initiated desktop update check fails',
  },
});
